export const ROLES = [
  'admin',
  'testmanager',
  'verantwortlicher',
  'consultant',
  'tester',
  'betrachter',
] as const;
export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Record<Role, { de: string; en: string }> = {
  admin: { de: 'Admin', en: 'Admin' },
  testmanager: { de: 'Testmanager / PL', en: 'Test Manager / PL' },
  verantwortlicher: { de: 'Verantwortlicher', en: 'Owner' },
  consultant: { de: 'Consultant', en: 'Consultant' },
  tester: { de: 'Tester', en: 'Tester' },
  betrachter: { de: 'Betrachter', en: 'Viewer' },
};

// Rollen, die auf einen Struktur-Knoten begrenzt sein können (Scope).
//
// NUR `verantwortlicher`. Die Berechtigungsmatrix (docs/requirements.md §5) führt den Consultant
// bei „Katalog pflegen" und „Defect bearbeiten" mit einem blanken ✔ — die Scope-Klammer steht dort
// ausschließlich beim Verantwortlichen. Solange `consultant` hier mitstand, wurde ein Consultant
// mit gesetztem `scope_node_id` von `can()` fail-closed abgewiesen und verlor genau die beiden
// Punkte, die laut Design-Spec §2.2 sein Kern sind (Defects + Zuordnung) — gemessen am 2026-09-09
// an der lokalen Instanz. Ein gesetzter Scope auf einer Consultant-Rolle ist ab jetzt eine
// Fehlkonfiguration: die Nutzerverwaltung bietet das Feld nicht mehr an und weist es ab
// (routes/users.ts), Migration 0012 räumt Altbestände auf.
export const SCOPED_ROLES: readonly Role[] = ['verantwortlicher'];
